import script from "./ProjectDetail.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProjectDetail.vue?vue&type=script&setup=true&lang=ts"

import "./ProjectDetail.vue?vue&type=style&index=0&id=6b036c6e&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6b036c6e"]])

export default __exports__